import { render, staticRenderFns } from "./RootModals.vue?vue&type=template&id=df8bbd08&"
import script from "./RootModals.vue?vue&type=script&lang=js&"
export * from "./RootModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports